import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'tasks-task-data-target',
  standalone: true,
  imports: [],
  templateUrl: './task-data-target.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskDataTargetComponent {}
